import { translationStatistics_da } from "./translationStatistics.da";
import { defineDashboardTranslations } from "./translationTypes";
import { translationStatistics_en } from "./translationStatistics.en";
import { translationStatistics_sv } from "./translationStatistics.sv";

export const translationStatistics = defineDashboardTranslations({
  da: translationStatistics_da,
  en: translationStatistics_en,
  sv: translationStatistics_sv,
});
